<script setup lang="ts">
import BackstageButton from '@/components/common/BackstageButton.vue';
import { usePricatDownload } from '@/features/pricat-download/usePricatDownload';
import { useI18n } from 'vue-i18n';

type Props = {
  season: string;
};

defineProps<Props>();

const { t } = useI18n();

const { downloadingPricat, getPricatIcon, fetchPricat } = usePricatDownload();
</script>

<template>
  <section class="pricat" aria-labelledby="pricat-title">
    <h3 class="pricat__title" id="pricat-title">{{ t('viewSelfSellIn.catalog_download.pricat_section_title') }}</h3>
    <div class="pricat__content pricat-content">
      <p class="pricat-content__text">{{ `${season} ${t('viewSelfSellIn.catalog_download.pricat_report_title')}` }}</p>
      <BackstageButton
        :icon-left="getPricatIcon"
        :disabled="downloadingPricat"
        @click="fetchPricat(season)"
        :aria-label="t('viewSelfSellIn.catalog_download.pricat_section_title')"
        data-cy-button="pricat-download-button" />
    </div>
  </section>
</template>

<style lang="scss" scoped>
.pricat {
  padding-bottom: 24px;
  border-bottom: solid 1px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  row-gap: 40px;

  &__title {
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1.3;
    text-align: left;
    margin: 0;
  }

  &__content {
    display: flex;
    align-items: center;
    column-gap: 24px;
  }
}

.pricat-content {
  &__text {
    font-size: 1.125rem;
    font-weight: 700;
    line-height: 1.3;
    margin: 0;
  }
}
</style>
